module.exports = __webpack_public_path__ + "static/Munchmuseet_43-fbbde16ff5e78b26a08f9ed433844d88.jpg";